{
  "aria.profileImage": "Profilbilete",
  "chooseIndustries": "Velg bransje",
  "chooseIndustriesText": "Velg bransjer dykkar kundar eller bedrifter jobbar innanfor",
  "heading": "Aktørprofil",
  "edit": "Rediger",
  "editProfile": "Rediger profil",
  "editActorProfile": "Rediger aktørprofil",
  "firstLineService": "Førstelinjetjeneste for",
  "generalInfo.commonEmail": "Felles e-post",
  "generalInfo.heading": "Generell informasjon",
  "generalInfo.optional": "Vi anbefalar å fylle ut så mange felt som mogleg for å auke synlegheita til organisasjonen",
  "logo": "Logo",
  "mainContact": "Hovudkontakt",
  "update": "Oppdater aktørprofil",
  "noActor": "Ingen aktørinformasjon blei funne",
  "noDescription": "Ingen beskrivelse er lagt til endå",
  "noDescription.cta": "Andre aktører kan ikkje se beskrivelsen dykkar",
  "noLogo": "Ingen logo er lasta opp",
  "noMainContact": "Ingen hovudkontakt er registrert",
  "noIndustry": "Ingen bransje er lagt til",
  "portfolioIndustries": "Bransjer innen portefølja",
  "services": "Tjenester",
  "goToCatalog": "Gå til felles tjenestekatalog",
  "workAreas": "Arbeidsområde",
  "showProfile": "Visning av aktørprofil",
  "loggedInAs": "Du er logga inn som {{ user }} for {{ actor }}.",
  "addViaAccessControl": "Finn du ikkje ansatte her eller vil du endre informasjonen til ein ansatt? Du kan legge til ansatte eller oppdatere informasjon i ",
  "informationSaved": "Informasjonen er lagra",
  "employeePhoto": "Ansattbilete",
  "mainContactPhoto": "Hovudkontaktbilete",
  "actorLogo": "Aktørlogo",
  "services.readMore": "Les meir om tjenestene i",
  "companyAgeRequirement": "Stillast det krav til bedrifta sin alder",
  "companySize": "Krav til bedriftsstorleik",
  "commonServiceCatalogue": "Felles tjenestekatalog",
  "noServices": "Ingen tjenester tilgjengelege, legg til tjenester i",
  "name": "Namn",
  "phone": "Tlf",
  "email": "E-post",
  "contactPerson": "Kontaktperson",
  "required.address": "Adresse må fyllast ut",
  "required.postalCode": "Postnummer må fyllast ut og vere eit fire-sifra tal"
}
